import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Punk",
  "description": "",
  "published": "2007-12-04T00:00:00.000Z",
  "redirect_from": ["/blog/punk/swizec/143"],
  "categories": "life, review",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Two, or was it three even, days ago there was a big punk concert here in Ljubljana. Pankrti had their 30 year reunion and decided against just having it at a pub getting shitfaced and rather give something to the fans as well. A memorable concert of a lifetime.`}</p>
    <p>{`Of a lifetime, not because it's something that good, but more because it's something that happens only once in your life. It's not every day you get to go to a concert of a band whose last concert before it was two years before you were born. And for such a thing to occur in your own home town? Get outta here.`}</p>
    <p>{`Unsurprisingly, but it still caught me off guard, the tickets sold out very quickly. In fact when I get to get mine five days after they'd begun selling two thirds of the place were sold out and I got weird tickets for some kind of seating where nobody ended up siting ...`}</p>
    <p>{`The concert itself was actually quite fun and I enjoyed it greatly. However it was very evident that those guys were kind of old as their antics on stage at times acquired aspects of parody and almost enduced laughter in me. I chose to disregard it of course and try my best to get in the flow of things and otherwise behave like a madman.`}</p>
    <p>{`The crowd, also, was not something I expected. There was a lot of merely standing and even siting as many were as old as the fellows on stage. But perhaps it was just that a certain mojo was missing and when that mojo is missing people simply don't jump around like crazy fucktards.`}</p>
    <p>{`All in all, I loved it and don't expect ever to do it again in my life.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      